import {
  FaTag,
  FaPercent,
  FaUtensils,
  FaSpa,
  FaPlane,
  FaBuilding,
  FaGem,
  FaShoppingBag,
  FaGift,
  FaDumbbell,
  FaRunning,
  FaCar,
  FaBus,
  FaTaxi,
  FaGraduationCap,
  FaBook,
  FaMusic,
  FaTheaterMasks,
  FaCamera,
  FaGamepad,
  FaHotel,
  FaUmbrellaBeach,
  FaHeartbeat,
  FaClinicMedical,
  FaPills,
  FaLaptop,
  FaMobileAlt,
  FaTools,
  FaBriefcase,
  FaUserTie,
  FaClock,
  FaCreditCard,
  FaShieldAlt,
  FaHeadset,
  FaEllipsisH
} from "react-icons/fa";
export const ICONS = {
 
  promotion: FaTag,
  reduction: FaPercent,
  deals: FaTag,
  exclusif: FaGem,
  shopping: FaShoppingBag,
  produits: FaShoppingBag,
  cadeaux: FaGift,

  restaurant: FaUtensils,
  restaurants: FaUtensils,
  cafe: FaUtensils,
  gastronomie: FaUtensils,

  spa: FaSpa,
  beaute: FaSpa,
  bienetre: FaSpa,
  cosmetiques: FaSpa,
  coiffure: FaSpa,
  sante: FaHeartbeat,
  clinique: FaClinicMedical,
  pharmacie: FaPills,

  sport: FaDumbbell,
  fitness: FaDumbbell,
  gym: FaDumbbell,
  running: FaRunning,

  voyage: FaPlane,
  tourisme: FaPlane,
  hotel: FaHotel,
  excursion: FaUmbrellaBeach,


  immobilier: FaBuilding,
  logement: FaBuilding,

  luxe: FaGem,
  premium: FaGem,

  loisirs: FaTheaterMasks,
  divertissement: FaTheaterMasks,
  musique: FaMusic,
  cinema: FaTheaterMasks,
  jeux: FaGamepad,
  photo: FaCamera,

  education: FaGraduationCap,
  formation: FaBook,
  cours: FaBook,

  voiture: FaCar,
  location_voiture: FaCar,
  taxi: FaTaxi,
  transport: FaBus,

  services: FaTools,
  business: FaBriefcase,
  professionnel: FaUserTie,
  rendezvous: FaClock,

  technologie: FaLaptop,
  mobile: FaMobileAlt,

  paiement: FaCreditCard,
  securite: FaShieldAlt,
  support: FaHeadset,

  autre: FaEllipsisH
};

export const renderCategoryIcon = (iconKey, size = 44, className = "text-[#e11d7b]") => {
  const key = String(iconKey || "").toLowerCase().trim();
  const Icon = ICONS[key] || ICONS.autre;
  return <Icon size={size} className={className} aria-hidden="true" />;
};
